module.exports = __webpack_public_path__ + "static/media/nonprofit-square.6e3228f5.jpg";